import { render, staticRenderFns } from "./Fitness.vue?vue&type=template&id=209eac6c&scoped=true"
import script from "./Fitness.vue?vue&type=script&lang=js"
export * from "./Fitness.vue?vue&type=script&lang=js"
import style0 from "./Fitness.vue?vue&type=style&index=0&id=209eac6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209eac6c",
  null
  
)

export default component.exports